import React from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import { ButtonProps } from '@mui/material';

interface SubmitButtonProps {
  title?: string;
  isLoading?: boolean;
  isDisabled?: boolean;
}

export function SubmitButton ({
  title,
  isDisabled,
  isLoading,
  ...rest
}: SubmitButtonProps & ButtonProps) {
  return (
    <LoadingButton
      disabled={isDisabled}
      loading={isLoading}
      disableElevation
      disableRipple
      variant="contained"
      {...rest}
    >
      {title}
    </LoadingButton>
  );
}
